import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import * as echarts from 'echarts';
import { onMounted, computed, ref, watch, toRaw } from 'vue';
export default {
  __name: 'ChartBar',
  props: {
    height: String,
    width: String,
    xAxis: {
      type: Array,
      default() {
        return [];
      }
    },
    series: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  setup(__props) {
    const props = __props;
    const contStyle = computed(() => ({
      height: props.height,
      width: props.width
    }));
    watch(() => props.series, val => {
      render();
    }, {
      deep: true
    });
    const chartCont = ref();
    let chart = undefined;
    function render() {
      if (!chartCont.value) {
        return;
      }
      if (!props.xAxis.length) {
        return;
      }
      if (!props.series.length) {
        return;
      }
      if (!chart) {
        chart = echarts.init(chartCont.value);
      }
      chart.setOption({
        // title: {
        //   text: 'Rainfall vs Evaporation',
        //   subtext: 'Fake Data'
        // },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          orient: 'vertical',
          right: 0,
          top: 'center'
        },
        toolbox: {
          show: true,
          feature: {
            dataView: {
              show: true,
              readOnly: false
            },
            magicType: {
              show: true,
              type: ['line', 'bar']
            },
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          data: props.xAxis
        }],
        yAxis: [{
          type: 'value'
        }],
        series: props.series
      });
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "chart",
        ref_key: "chartCont",
        ref: chartCont,
        style: _normalizeStyle(contStyle.value)
      }, null, 4);
    };
  }
};